import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, } from '@/api/async-util'

const types = {
    IS_DISCOUNT_CODE_VALID: createAsyncMutation('IS_DISCOUNT_CODE_VALID')
}

const discountCode = {
    state: {},
    mutations: {},
    actions: {
        // GET
        validateDiscountCode(store, id) {
            let url = api.discountCode
            if (id) {
                url += '?id=' + id
            }
            return doAsyncGet(store, { url, mutationTypes: types.IS_DISCOUNT_CODE_VALID })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default discountCode
